var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

export function scrollToSmoothly(pos, time, element = window) {
  let currentPos = element.pageYOffset
  let start = null
  if (time == null) time = 500
  ;(pos = +pos), (time = +time)
  element.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start
    let progress = currentTime - start
    if (currentPos < pos) {
      element.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos)
    } else {
      element.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time)
    }
    if (progress < time) {
      element.requestAnimationFrame(step)
    } else {
      element.scrollTo(0, pos)
    }
  })
}